.cya11y-rg{position:fixed;top:0;left:0;right:0;width:100%;height:0;pointer-events:none;background-color:#0009;z-index:1000000}
